import React, { useState, useEffect } from 'react';
import {
  EMAIL_CONTACTO,
  WHATSAPP_NUMERO,
  abrirWhatsApp,
  abrirMailContacto,
} from '../utils/contacto';
import './ConsultaModal.css';

const MAX_CARACTERES_WHATSAPP = 300;

const ICONO_WHATSAPP = (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="consulta-modal__wa-icono">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const TITULOS = {
  menu: 'Contactanos',
  email: 'Enviar mail',
  whatsapp: 'Enviar mensaje por WhatsApp',
};

function ConsultaModal({
  isOpen,
  onClose,
  numeroWhatsApp = WHATSAPP_NUMERO,
  emailDestino = EMAIL_CONTACTO,
  vistaInicial = 'menu',
}) {
  const [vista, setVista] = useState(vistaInicial);
  const [mensajeWhatsApp, setMensajeWhatsApp] = useState('');
  const [correoUsuario, setCorreoUsuario] = useState('');
  const [asunto, setAsunto] = useState('');
  const [cuerpoMail, setCuerpoMail] = useState('');
  const [mailError, setMailError] = useState('');
  const [mailExito, setMailExito] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setVista(vistaInicial);
    setMensajeWhatsApp('');
    setCorreoUsuario('');
    setAsunto('');
    setCuerpoMail('');
    setMailError('');
    setMailExito(false);
  }, [isOpen, vistaInicial]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key !== 'Escape') return;
      if (vista !== 'menu' && vistaInicial === 'menu') {
        setVista('menu');
        return;
      }
      onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose, vista, vistaInicial]);

  const volverAlMenu = () => {
    if (vistaInicial !== 'menu') {
      onClose();
      return;
    }
    setVista('menu');
  };

  const handleIrAlChat = () => {
    abrirWhatsApp(numeroWhatsApp, mensajeWhatsApp);
    onClose();
  };

  const handleEnviarMail = (e) => {
    e.preventDefault();
    setMailError('');
    setMailExito(false);
    try {
      abrirMailContacto({
        destino: emailDestino,
        correoUsuario,
        asunto,
        cuerpo: cuerpoMail,
      });
      setMailExito(true);
      setTimeout(() => onClose(), 3500);
    } catch (err) {
      setMailError(err.message || 'No se pudo abrir el correo.');
    }
  };

  if (!isOpen) return null;

  const mostrarVolver = vista !== 'menu' && vistaInicial === 'menu';

  return (
    <div className="consulta-modal" role="dialog" aria-modal="true" aria-labelledby="consulta-modal-titulo">
      <div className="consulta-modal__backdrop" onClick={onClose} aria-hidden="true" />
      <div className="consulta-modal__ventana">
        <div className="consulta-modal__encabezado">
          <div className="consulta-modal__encabezado-izq">
            {mostrarVolver ? (
              <button
                type="button"
                className="consulta-modal__volver"
                onClick={volverAlMenu}
                aria-label="Volver"
              >
                ‹
              </button>
            ) : null}
            <h2 id="consulta-modal-titulo" className="consulta-modal__titulo">
              {TITULOS[vista]}
            </h2>
          </div>
          <button
            type="button"
            className="consulta-modal__cerrar"
            onClick={onClose}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>

        <div className="consulta-modal__cuerpo">
          {vista === 'menu' && (
            <div className="consulta-modal__opciones">
              <button
                type="button"
                className="consulta-modal__opcion consulta-modal__opcion--mail"
                onClick={() => setVista('email')}
              >
                <span className="consulta-modal__opcion-icono" aria-hidden="true">
                  ✉
                </span>
                Enviar mail
              </button>
              <button
                type="button"
                className="consulta-modal__opcion consulta-modal__opcion--wa"
                onClick={() => setVista('whatsapp')}
              >
                <span className="consulta-modal__opcion-icono consulta-modal__opcion-icono--wa" aria-hidden="true">
                  {ICONO_WHATSAPP}
                </span>
                Enviar mensaje por WhatsApp
              </button>
            </div>
          )}

          {vista === 'email' && (
            <form className="consulta-modal__form-mail" onSubmit={handleEnviarMail}>
              <div className="consulta-modal__campo-mail-destino">
                <span className="consulta-modal__label">Enviar a</span>
                <span className="consulta-modal__email-link consulta-modal__email-link--estatico">
                  {emailDestino}
                </span>
              </div>
              <label className="consulta-modal__label-block">
                <span className="consulta-modal__label">Tu correo</span>
                <input
                  type="email"
                  className="consulta-modal__input"
                  value={correoUsuario}
                  onChange={(e) => setCorreoUsuario(e.target.value)}
                  placeholder="tu@correo.com"
                  autoComplete="email"
                  required
                  disabled={mailExito}
                />
              </label>
              <label className="consulta-modal__label-block">
                <span className="consulta-modal__label">Asunto</span>
                <input
                  type="text"
                  className="consulta-modal__input"
                  value={asunto}
                  onChange={(e) => setAsunto(e.target.value)}
                  placeholder="Asunto del mensaje"
                  autoComplete="off"
                  required
                  disabled={mailExito}
                />
              </label>
              <label className="consulta-modal__label-block consulta-modal__label-block--grow">
                <span className="consulta-modal__label">Mensaje</span>
                <textarea
                  className="consulta-modal__textarea consulta-modal__textarea--mail"
                  value={cuerpoMail}
                  onChange={(e) => setCuerpoMail(e.target.value)}
                  placeholder="Escribe tu mensaje aquí..."
                  rows={4}
                  required
                  disabled={mailExito}
                />
              </label>
              {mailError ? (
                <p className="consulta-modal__feedback consulta-modal__feedback--error" role="alert">
                  {mailError}
                </p>
              ) : null}
              {mailExito ? (
                <p className="consulta-modal__feedback consulta-modal__feedback--ok" role="status">
                  Correo abierto. Iniciá sesión si hace falta y confirmá el envío.
                </p>
              ) : null}
              <button
                type="submit"
                className="consulta-modal__btn consulta-modal__btn--mail"
                disabled={mailExito}
              >
                Abrir en mi correo
              </button>
            </form>
          )}

          {vista === 'whatsapp' && (
            <div className="consulta-modal__form-wa">
              <div className="consulta-modal__textarea-wrap">
                <textarea
                  className="consulta-modal__textarea"
                  placeholder="Escribe tu mensaje aquí..."
                  value={mensajeWhatsApp}
                  onChange={(e) => setMensajeWhatsApp(e.target.value.slice(0, MAX_CARACTERES_WHATSAPP))}
                  maxLength={MAX_CARACTERES_WHATSAPP}
                  rows={5}
                />
                <span className="consulta-modal__contador">
                  {mensajeWhatsApp.length}/{MAX_CARACTERES_WHATSAPP}
                </span>
              </div>
              <button
                type="button"
                className="consulta-modal__btn-wa"
                onClick={handleIrAlChat}
              >
                {ICONO_WHATSAPP}
                Ir al chat
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ConsultaModal;
